import SobreMim from "paginas/SobreMim";
import Projetos from "paginas/Projetos";
import Setas from "componentes/Setas";

export default function Inicio() {
  return (
    <>
      <Setas />
      <SobreMim />
      <Projetos />
    </>
  );
}
